import { useState, useEffect } from "react";

export default function HeaderClock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const day = now.toLocaleDateString("en-US", { weekday: "long" });

  const date = now.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  return (
    <div className="hidden sm:flex items-center gap-2 text-white/90 text-sm font-mono select-none">
      <span className="text-white font-semibold tracking-wide">{time}</span>
      <span className="text-white/60 text-xs hidden md:inline">|</span>
      <span className="text-white/60 text-xs hidden md:inline">{day}</span>
      <span className="text-white/60 text-xs hidden md:inline">|</span>
      <span className="text-white/60 text-xs hidden md:inline">{date}</span>
    </div>
  );
}
